import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type Contexto = 'negociacao' | 'pedido_fechado' | 'rascunho';

export interface ObrigatoriedadeConfig {
  id: string;
  mensagem_erro: string;
  mensagem_ajuda: string;
  validacao_regex: string | null;
  valor_default: string | null;
  minimo: number | null;
  maximo: number | null;
  permite_multiplos: boolean;
  obrigatorio_em_negociacao: boolean;
  obrigatorio_em_pedido_fechado: boolean;
  obrigatorio_em_rascunho: boolean;
  obrigatoriedades_catalogo: {
    id: string;
    codigo: string;
    nome: string;
    tipo_dado: string;
    campo_tabela: string;
  };
}

export function useObrigatoriedadesItem(
  produtoId: string | null,
  contexto: Contexto = 'negociacao',
  ignorarContexto: boolean = false
) {
  return useQuery({
    queryKey: ['obrigatoriedades-item', produtoId, contexto, ignorarContexto],
    queryFn: async () => {
      if (!produtoId) return null;

      // 1. Buscar grupo do produto
      const { data: produto } = await supabase
        .from('produtos')
        .select('grupo_obrigatoriedade_id, nome')
        .eq('id', produtoId)
        .maybeSingle();

      if (!produto?.grupo_obrigatoriedade_id) return null;

      // 2. Buscar obrigatoriedades do grupo
      const query = supabase
        .from('grupo_obrigatoriedades_config')
        .select(`
          id,
          mensagem_erro,
          mensagem_ajuda,
          validacao_regex,
          valor_default,
          minimo,
          maximo,
          permite_multiplos,
          obrigatorio_em_negociacao,
          obrigatorio_em_pedido_fechado,
          obrigatorio_em_rascunho,
          obrigatoriedade_id,
          obrigatoriedades_catalogo:obrigatoriedade_id (
            id,
            codigo,
            nome,
            tipo_dado,
            campo_tabela
          )
        `)
        .eq('grupo_id', produto.grupo_obrigatoriedade_id)
        .eq('ativo', true);

      const { data, error } = await query;

      if (error) {
        console.error('❌ Erro ao buscar obrigatoriedades:', error);
        return null;
      }

      // 3. Filtrar por contexto após buscar (se não ignorar)
      let resultado = (data || []) as unknown as ObrigatoriedadeConfig[];
      
      console.log('🔍 useObrigatoriedadesItem:', {
        produtoId,
        contexto,
        ignorarContexto,
        totalAntesFiltro: resultado.length,
        campos: resultado.map(r => r.obrigatoriedades_catalogo.codigo)
      });
      
      if (!ignorarContexto) {
        resultado = resultado.filter(item => {
          if (contexto === 'pedido_fechado') {
            return item.obrigatorio_em_pedido_fechado;
          } else if (contexto === 'rascunho') {
            return item.obrigatorio_em_rascunho;
          }
          return item.obrigatorio_em_negociacao;
        });
      }

      console.log('✨ Após filtro:', {
        totalDepoisFiltro: resultado.length,
        camposFiltrados: resultado.map(r => r.obrigatoriedades_catalogo.codigo)
      });

      return resultado;
    },
    enabled: !!produtoId,
  });
}
